import React from 'react';
import { Typography } from 'src/components/PulseUI';

const OverlayColumn = (_props) => {
  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: '#E5F3FB' }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-center h-full p-4">
        <div className="mt-6 w-[200px]">
          <Typography
            variant="body2"
            color="secondary"
            className="whitespace-pre-wrap text-center"
          >
            No Saved Search filters applied. Click the &quot;+&quot; button
            above to add.
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default OverlayColumn;
